import { FeatureSwitches } from './feature-switches';
export var remorseCancelPeriod = FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.remorseCancelPeriod;
export var cancellationPolicyURL = 'https://www.homedepot.com/c/Customer_Support_Answers';
export var returnPolicyURL = 'https://www.homedepot.com/c/Return_Policy';
export var CANCEL_ALERT_MESSAGE;
(function (CANCEL_ALERT_MESSAGE) {
    CANCEL_ALERT_MESSAGE["ERROR"] = "We're having technical difficulties.  The following items can't be canceled at this time.";
    CANCEL_ALERT_MESSAGE["QTY_ZERO"] = "Please enter the quantity for the product(s) you'd like to cancel.";
    CANCEL_ALERT_MESSAGE["SUCCESS"] = "You've successfully canceled the following items.  You'll receive an email confirmation shortly.";
    CANCEL_ALERT_MESSAGE["PRCR_SUBMITTED"] = "You've requested to cancel this order. You'll receive an email if your cancellation is approved.";
    CANCEL_ALERT_MESSAGE["PRCR_SUCCESSFUL"] = "Item(s) were successfully canceled from this order.";
})(CANCEL_ALERT_MESSAGE || (CANCEL_ALERT_MESSAGE = {}));
